function TermsPage() {
  return (
    <div className="legal-page">
      <h1>用户协议</h1>
      <p className="last-updated">最后更新日期：2026年3月30日</p>

      <div className="warning-box">
        <p><strong>重要提示</strong>：TradeMirror 是一款交易日志与行为分析工具，<strong>不提供任何投资建议、股票推荐或交易信号</strong>。所有分析结果仅供您个人参考，不构成任何投资决策依据。投资有风险，入市需谨慎。</p>
      </div>

      <p>欢迎您使用 TradeMirror（"本应用"），由 Ji'an Jizhou District Hilo Internet Studio（"我们"）提供的服务。本用户协议（"本协议"）是您与 TradeMirror 之间关于使用我们服务的法律协议。请您在使用我们的服务前仔细阅读本协议的全部内容。</p>

      <h2>一、服务说明</h2>
      
      <h3>1.1 服务内容</h3>
      <p>TradeMirror 是一款面向 A 股散户投资者的交易日志与行为分析工具，提供以下核心服务：</p>
      <ul>
        <li>交易计划记录与管理</li>
        <li>持仓变化跟踪</li>
        <li>交易复盘记录</li>
        <li>基于 AI 的交易行为分析</li>
        <li>个人交易画像生成</li>
      </ul>

      <h3>1.2 服务性质声明</h3>
      <div className="warning-box">
        <p><strong>特别声明</strong>：</p>
        <ul style={{ marginBottom: 0 }}>
          <li>本应用 <strong>不是</strong>证券交易软件，不提供交易执行功能</li>
          <li>本应用 <strong>不是</strong>投资咨询平台，不提供任何投资建议或股票推荐</li>
          <li>AI 分析结果<strong>仅供个人参考</strong>，不构成投资决策依据</li>
          <li>我们不对任何投资盈亏承担责任</li>
        </ul>
      </div>

      <h2>二、账户注册与使用</h2>
      
      <h3>2.1 注册要求</h3>
      <ul>
        <li>您必须年满 18 周岁才能使用本服务</li>
        <li>您可以通过 Apple 登录或匿名方式使用本应用</li>
        <li>您需要提供一个有效的电子邮件地址用于账户恢复和重要通知</li>
      </ul>

      <h3>2.2 账户安全</h3>
      <ul>
        <li>您应对您的账户安全负责，妥善保管登录凭证</li>
        <li>如发现账户被盗用或存在安全风险，请立即联系我们</li>
        <li>因您保管不善导致的损失，我们不承担责任</li>
      </ul>

      <h2>三、订阅与付款</h2>
      
      <h3>3.1 服务版本</h3>
      <ul>
        <li><strong>免费版</strong>：提供基础的交易记录功能，限制 20 笔交易历史</li>
        <li><strong>VIP 版</strong>：提供无限历史记录、AI 深度分析等高级功能</li>
      </ul>

      <h3>3.2 订阅条款</h3>
      <ul>
        <li>VIP 订阅通过 Apple App Store 处理，受 Apple 的条款约束</li>
        <li>订阅采用自动续费模式，您可随时在设备设置中取消</li>
        <li>取消订阅后，您仍可使用 VIP 功能直到当前计费周期结束</li>
        <li>退款事宜遵循 Apple App Store 的退款政策</li>
      </ul>

      <h3>3.3 价格调整</h3>
      <p>我们保留调整 VIP 订阅价格的权利。任何价格调整将在下一个计费周期生效，并会提前通知您。</p>

      <h2>四、用户行为规范</h2>
      
      <h3>4.1 禁止行为</h3>
      <p>您同意在使用本服务时不会：</p>
      <ul>
        <li>使用本应用进行任何非法活动</li>
        <li>尝试破解、反向工程或干扰本应用的正常运行</li>
        <li>使用自动化工具（机器人、爬虫等）访问本服务</li>
        <li>传播恶意软件、病毒或其他有害代码</li>
        <li>冒充他人或提供虚假信息</li>
        <li>骚扰、威胁或侵犯其他用户的权益</li>
      </ul>

      <h3>4.2 内容规范</h3>
      <p>您在应用内记录的交易数据应：</p>
      <ul>
        <li>真实反映您的交易情况（尽管我们无法验证其真实性）</li>
        <li>不包含任何违法违规内容</li>
        <li>不包含侵犯他人知识产权的内容</li>
      </ul>

      <h2>五、知识产权</h2>
      
      <h3>5.1 我们的权利</h3>
      <ul>
        <li>TradeMirror 应用及其所有内容（包括但不限于代码、界面设计、图标、文档）的知识产权归我们所有</li>
        <li>本协议不授予您使用我们商标、标识的权利</li>
      </ul>

      <h3>5.2 您的权利</h3>
      <ul>
        <li>您保留您在应用内输入的交易记录的所有权</li>
        <li>VIP 用户可以导出个人交易数据供个人使用</li>
        <li>您授予我们必要的许可，以便我们为您提供数据同步、AI 分析等服务</li>
      </ul>

      <h2>六、免责声明</h2>
      
      <h3>6.1 服务可用性</h3>
      <ul>
        <li>我们尽力确保服务的稳定性和可用性，但不保证服务不会中断或无错误</li>
        <li>我们可能会定期进行维护，期间服务可能暂时不可用</li>
      </ul>

      <h3>6.2 AI 分析结果</h3>
      <div className="warning-box">
        <p><strong>重要免责声明</strong>：本应用的 AI 分析功能基于算法和模型生成，可能存在局限性、偏差或错误。AI 分析结果：</p>
        <ul style={{ marginBottom: 0 }}>
          <li>仅供您个人反思和参考</li>
          <li>不构成任何投资建议或交易指导</li>
          <li>不保证任何投资结果</li>
          <li>您应对自己的投资决策负全部责任</li>
        </ul>
      </div>

      <h3>6.3 投资风险</h3>
      <p>您明确理解并同意：</p>
      <ul>
        <li>证券投资存在风险，可能导致本金损失</li>
        <li>过往业绩不代表未来表现</li>
        <li>您应基于自己的判断做出投资决策</li>
        <li>必要时咨询专业的投资顾问</li>
      </ul>

      <h3>6.4 责任限制</h3>
      <p>在法律允许的最大范围内，我们不对以下情况承担责任：</p>
      <ul>
        <li>因使用或无法使用本服务而导致的任何直接、间接、附带或后果性损失</li>
        <li>因数据丢失或损坏导致的损失</li>
        <li>因您依赖 AI 分析结果做出的投资决策导致的任何财务损失</li>
      </ul>

      <h2>七、协议变更与终止</h2>
      
      <h3>7.1 协议变更</h3>
      <p>我们保留随时修改本协议的权利。重大变更将通过应用内通知或邮件告知您。继续使用本服务即表示您接受修订后的协议。</p>

      <h3>7.2 服务终止</h3>
      <ul>
        <li>您可以随时停止使用本服务</li>
        <li>我们保留在以下情况下终止您账户的权利：违反本协议、长时间不活跃、法律要求等</li>
        <li>账户终止后，您的数据将根据我们的隐私政策处理</li>
      </ul>

      <h2>八、适用法律与争议解决</h2>
      <ul>
        <li>本协议受中华人民共和国法律管辖</li>
        <li>因本协议引起的或与本协议相关的任何争议，双方应友好协商解决</li>
        <li>协商不成的，任何一方均可向有管辖权的人民法院提起诉讼</li>
      </ul>

      <h2>九、其他条款</h2>
      <ul>
        <li>本协议构成您与我们之间关于使用本服务的完整协议</li>
        <li>如本协议任何条款被认定为无效或不可执行，不影响其他条款的效力</li>
        <li>我们未行使或执行本协议的任何权利不构成对该权利的放弃</li>
      </ul>

      <h2>十、联系我们</h2>
      <p>如果您对本用户协议有任何疑问，请通过以下方式联系我们：</p>
      <ul>
        <li>电子邮件：<a href="mailto:support@taroveil.com">support@taroveil.com</a></li>
        <li>应用内反馈：设置 → 反馈与建议</li>
      </ul>

      <div className="highlight-box">
        <p style={{ marginBottom: 0 }}><strong>同意条款</strong>：下载、安装或使用本应用 即表示您已阅读、理解并同意受本用户协议的约束。如果您不同意本协议的任何条款，请勿使用本服务。</p>
      </div>
    </div>
  )
}

export default TermsPage
